import React from "react";
import TableUtility from "../../../Common/UtilityCommon/TableUtility";

const AwakEntryUtility = ({ includeYearCode = true }) => {
   const apiUrl = `${process.env.REACT_APP_API}/getdata-AwakEntry`;
   const columns = [
      { label: "Doc No", key: "Doc_No" },
      { label: "Doc Date", key: "Doc_Date" },
      { label: "Farmer", key: "Ac_Name_E" },
      { label: "Broker", key: "Broker" },
      { label: "Quantity", key: "totalQty" },
      { label: "NetWt", key: "Totalnetwt" },
   ];
   return (
      <TableUtility
         title="Awak Entries"
         apiUrl={apiUrl}
         columns={columns}
         rowKey="Id"
         addUrl="/Awakentry-api"
         detailUrl="/Awakentry-api"
         permissionUrl="/Awaka-Entry-utility"
         includeYearCode={includeYearCode}

      />
   );

};

export default AwakEntryUtility;